import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import "./legacy.css";
import Landing from "./pages/Landing";
import Alliances from "./pages/Alliances";
import VerifiedPartnershipsPage from "./pages/VerifiedPartnershipsPage";
import Employers from "./pages/Employers";
import UCMS from "./pages/UCMS";
import PublicImpact from "./pages/PublicImpact";
import LaborCalculator from "./pages/LaborCalculator";
import IntakeWizard from "./pages/IntakeWizard";
import PublicRoadmap from "./pages/PublicRoadmap";
import FourPillars from "./pages/FourPillars";
import Donate from "./pages/Donate";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import SecurityCompliance from "./pages/SecurityCompliance";
import HipaaNotice from "./pages/HipaaNotice";
import BaaRequestPage from "./pages/BaaRequestPage";
import PublicEventsPage from "./pages/PublicEventsPage";
import SupportersPage from "./pages/SupportersPage";
import LifeEmpowermentLayout from "./pages/life/LifeEmpowermentLayout";
import { LifeHome, LifeAbout, LifeServices, LifeRecognition, LifeContact, LifePrivacy, LifeTerms } from "./pages/life/LifeEmpowermentPages";
import SmsPrivacyPolicy from "./pages/sms/SmsPrivacyPolicy";
import SmsTerms from "./pages/sms/SmsTerms";
import SmsSubscribe from "./pages/sms/SmsSubscribe";

export const LEGACY_PREFIXES = ["/home", "/alliances", "/employers", "/personal-advancement-career-training", "/impact", "/labor",
  "/intake", "/roadmap", "/four-pillars", "/donate", "/legal/", "/events", "/life-empowerment", "/supporters", "/sms/"];

export const isLegacyPath = (p) => p === "/" || LEGACY_PREFIXES.some((x) => p === x || p.startsWith(x.endsWith("/") ? x : `${x}/`));

const FONTS = [
  "https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@500,700,800,900&display=swap",
  "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&display=swap",
  "https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap",
];

const useLegacyFonts = () => useEffect(() => {
  FONTS.forEach((href) => {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const l = document.createElement("link");
    l.rel = "stylesheet"; l.href = href;
    document.head.appendChild(l);
  });
}, []);

export default function LegacySite() {
  useLegacyFonts();
  return (
    <div className="tea-legacy" data-testid="legacy-site">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/alliances" element={<Alliances />} />
        <Route path="/alliances/verified" element={<VerifiedPartnershipsPage />} />
        <Route path="/employers" element={<Employers />} />
        <Route path="/personal-advancement-career-training" element={<UCMS />} />
        <Route path="/impact" element={<PublicImpact />} />
        <Route path="/labor" element={<LaborCalculator />} />
        <Route path="/intake" element={<IntakeWizard />} />
        <Route path="/roadmap" element={<PublicRoadmap />} />
        <Route path="/four-pillars" element={<FourPillars />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/legal/terms" element={<TermsOfService />} />
        <Route path="/legal/security" element={<SecurityCompliance />} />
        <Route path="/legal/hipaa" element={<HipaaNotice />} />
        <Route path="/legal/baa" element={<BaaRequestPage />} />
        <Route path="/events" element={<PublicEventsPage />} />
        <Route path="/life-empowerment" element={<LifeEmpowermentLayout />}>
          <Route index element={<LifeHome />} />
          <Route path="about" element={<LifeAbout />} />
          <Route path="services" element={<LifeServices />} />
          <Route path="recognition" element={<LifeRecognition />} />
          <Route path="contact" element={<LifeContact />} />
          <Route path="privacy" element={<LifePrivacy />} />
          <Route path="terms" element={<LifeTerms />} />
          <Route path="training" element={<Navigate to="/life-empowerment/services" replace />} />
          <Route path="consulting" element={<Navigate to="/life-empowerment/services" replace />} />
        </Route>
        <Route path="/supporters" element={<SupportersPage />} />
        <Route path="/sms/privacy" element={<SmsPrivacyPolicy />} />
        <Route path="/sms/terms" element={<SmsTerms />} />
        <Route path="/sms/subscribe" element={<SmsSubscribe />} />
      </Routes>
    </div>
  );
}
